import Img from 'gatsby-image'
import styled from 'styled-components'

import media from '../../util/media'

export const ChefAvatarWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  ${media.lessThan('sm')`
    margin-bottom: 24px;
  `}
`

export const ChefAvatarImage = styled(Img)`
  width: 100%;
  height: auto;
`
